import { render, staticRenderFns } from "./OfflineRecallsRow.vue?vue&type=template&id=52b18c60"
import script from "./OfflineRecallsRow.vue?vue&type=script&lang=js"
export * from "./OfflineRecallsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports